import { render } from "./BoutonPaiement.vue?vue&type=template&id=46838c86&scoped=true"
import script from "./BoutonPaiement.vue?vue&type=script&lang=js"
export * from "./BoutonPaiement.vue?vue&type=script&lang=js"

import "./BoutonPaiement.vue?vue&type=style&index=0&id=46838c86&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46838c86"]])

export default __exports__